import { ApiDomain } from "@/shared/utils";
import { AccountInfo } from "@azure/msal-browser";
import { createContext } from "react";
import { UserRole } from "../types";

/**
 * Authentication context type definition
 */
export interface AuthContextType {
    /** Current authenticated user */
    user: AccountInfo | null;
    /** Whether user is authenticated */
    isAuthenticated: boolean;
    /** Authentication loading state */
    isLoading: boolean;
    /** Authentication error if any */
    error: Error | null;
    /** Login method */
    login: () => void;
    /** Logout method */
    logout: () => void;
    /** Get access token for API calls */
    getAccessToken: () => Promise<string>;
    /** Check if user has a specific role. If onlyCheckADGroups is true, ignores preview role */
    hasRole: (role: UserRole, onlyCheckADGroups?: boolean) => boolean;
    /** Check if user has any valid AD group mapped to application roles */
    hasAnyRole: () => boolean;
    /** Primary role to determine which endpoints to call */
    apiDomain: ApiDomain | null;
    /** Preview role for content-only switching (admin only) */
    previewRole: UserRole | null;
    /** Set preview role (admin only). Use null to clear. */
    setPreviewRole: (role: UserRole | null) => void;
}

/**
 * Context for authentication functionality
 */
export const AuthContext = createContext<AuthContextType | null>(null);
